"use client";

import { SwiperSlide } from "swiper/react";
import SwiperCarousel from "@/components/plugins/swiper/SwiperCarousel";
import TextSubHeader from "@/components/typography/TextSubHeader";
import TextHeader from "@/components/typography/TextHeader";
import TextContent from "@/components/typography/TextContent";
import SwiperSlideImage from "@/components/plugins/swiper/SwiperSlideImage";
import imgSlide1 from "@/assets/images/screens/homepage/nature-pros-1.jpg";
import imgSlide2 from "@/assets/images/screens/homepage/nature-pros-2.jpg";
import imgSlide3 from "@/assets/images/screens/homepage/nature-pros-3.jpg";
import imgSlide4 from "@/assets/images/screens/homepage/nature-pros-4.jpg";
import imgSlide5 from "@/assets/images/screens/homepage/nature-pros-5.jpg";
import imgSlide6 from "@/assets/images/screens/homepage/nature-pros-6.jpg";
import DrawNaturePros from "@/screens/homepage/components/drawings/DrawNaturePros";

export default function NaturePros() {
  const slides = [
    {
      image: imgSlide1,
      content: "Wyjątkowy i indywidualny wypoczynek",
    },
    {
      image: imgSlide6,
      content:
        "Beskid Sport Arena – 4 trasy zjazdowe, wypożyczalnia, szkoła narciarska",
    },
    {
      image: imgSlide2,
      content:
        "Szczyrk Mountain Resort - największy ośrodek narciarski w Polsce",
    },
    {
      image: imgSlide3,
      content: "Ponad 40 km tras zjazdowych",
    },
    {
      image: imgSlide4,
      content: "Ponad 50 km tras rowerowych w tym singletracks",
    },
    {
      image: imgSlide5,
      content: "Unikalne miejsce na spacery i hiking",
    },
  ];

  return (
    <div className="overflow-hidden pb-16 pt-12 lg:pb-24 lg:pt-24">
      <div className="mb-16 lg:mb-24">
        <div className="m-auto max-w-screen-sm px-5">
          <div className="relative z-10">
            <TextSubHeader>Okolica</TextSubHeader>
            <TextHeader>
              <span className="relative inline-block">
                <span className="relative z-10">
                  Siła gór i harmonia natury
                </span>
                <DrawNaturePros className="absolute left-0 right-0 top-8 lg:top-6" />
              </span>
            </TextHeader>
            <TextContent>
              Odkryj magię Szczyrku – miejsca, gdzie czyste powietrze,
              zapierające dech widoki i aktywny wypoczynek tworzą idealny
              przepis na relaks. Góry są tu na wyciągnięcie ręki, a wspomnienia
              na zawsze.
            </TextContent>
          </div>
        </div>
      </div>
      <SwiperCarousel>
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <SwiperSlideImage image={slide.image}>
              {slide.content}
            </SwiperSlideImage>
          </SwiperSlide>
        ))}
      </SwiperCarousel>
    </div>
  );
}
